export default __webpack_public_path__ + "static/media/chevron-down.f7ac5a96.svg";